import firebase from 'firebase';
// process.env.REACT_APP_
var firebaseConfig = {
    apiKey: "AIzaSyDIwXP3L4DPoEysuE6wYaaPNdaWaRj6enM",
    authDomain: "feelthemusic-db.firebaseapp.com",
    databaseURL: "https://feelthemusic-db-default-rtdb.firebaseio.com",
    projectId: "feelthemusic-db",
    storageBucket: "feelthemusic-db.appspot.com",
    messagingSenderId: "1086243314487",
    appId: "1:1086243314487:web:50dd5a08624e30719f98b2",
    measurementId: "G-36XDSNRQP1"
};

// Initialize Firebase
const fire = firebase.initializeApp(firebaseConfig);
// firebase.analytics();

export default fire;